import { IFilterOption, IPagination, Typeregion } from "@interfaces";
import {
  enumAdminRole,
  enumAgeGroup,
  enumFilter,
  enumGender,
  enumProductFilter,
  enumReferred,
  enumStatus,
} from "./enum";

export const API_URL = process.env.REACT_APP_API_URL as string;
export const maxMobile = 768 as number;
export const timeOut = 3 as number;
export const pageNumber = 1 as number;
export const pageLimit = 10 as number;
export const couponLen = 8 as number;
export const mmPhoneLen = 11 as number;
export const STEP_ONE = 1;
export const STEP_TWO = 2;
export const STEP_THREE = 3;
export const STEP_FOUR = 4;
export const YES = "Yes";
export const NO = "No";
export const Old_Client = "Old Client";
export const IUD = "IUD";
export const OTHER = "Others";
export const UNFAVORABLE_FOR_INSERTION = "Unfavorable for insertion";
export const VIA_RESULT = "VIA Result+";
export const REFERRED = "Referred";
export const IMPLANT = "Implant";
export const MALE = "Male";
export const FEMALE = "Female";
export const adminFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [enumFilter.NAME, enumFilter.EMAIL],
  },
  {
    label: "date_by",
    children: [enumFilter.DATE],
  },
];
export const couponFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [
      enumFilter.DEFAULT,
      enumFilter.PROGERAM_NAME,
      enumFilter.SERVICE_NAME,
      enumFilter.COUPON_FAMILY,
    ],
  },
];
export const cdicCouponFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [
      enumFilter.DEFAULT,
      enumFilter.PROGERAM_NAME,
      enumFilter.COUPON_CODE
    ],
  },
];

export const cdicCouponCategory: IFilterOption[] = [
  {
    label: "filter_by",
    children: [
      enumFilter.DEFAULT,
      enumFilter.PROGERAM_NAME
    ],
  },
];

export const contraceptionFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [enumFilter.CLINIC_NAME, enumFilter.SUBMITTED_BY],
  },
  {
    label: "date_by",
    children: [enumFilter.DATE],
  },
];
export const couponFamilyFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [
      enumFilter.DEFAULT,
      enumFilter.PROGERAM_NAME,
      enumFilter.SERVICE_NAME,
      enumFilter.CLIENT_NAME,
    ],
  },
];
export const clientFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [enumFilter.CLIENT_NAME, enumFilter.CLIENT_PHONE, enumFilter.REFERREDBY],
  },
];
export const patientFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [enumFilter.DATE],
  },
];

export const userRoles = [enumAdminRole.SUPER, enumAdminRole.ADMIN, enumAdminRole.NORMAL];

export const clinicFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [enumFilter.CLINIC_NAME, enumFilter.PHONE_NUMBER],
  },
];

export const initPage: IPagination = {
  page: pageNumber,
  limit: pageLimit,
};

export const gender = [enumGender.MALE, enumGender.FEMALE];

export const ageGroups = [enumAgeGroup.ADULT, enumAgeGroup.CHILD];

export const familyFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: [enumFilter.CLIENT_NAME, enumFilter.COUPON_CODE],
  },
  {
    label: "date_by",
    children: [enumFilter.DATE],
  },
];

export const productFilter: IFilterOption[] = [
  {
    label: "filter_by",
    children: Object.values(enumProductFilter),
  },
  {
    label: "date_by",
    children: [enumFilter.DATE],
  },
];

export const geastral = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
export const dateFormat = "DD-MM-YYYY";
export const formatDateTime = "DD-MM-YYYY HH:mm";

export const region_towship: Typeregion = {
  ayeyarwady: ["Bogale", "Pyapon", "Maubin", "Wakema", "Myaungmya", "Pathein"],
  bago: ["Bago", "Kyauktaga", "Pyay", "Nyaunglebin", "Taungoo"],
  yangon: [
    "Hlaingthayar",
    "Hlegu",
    "Thanlyn",
    "Dagon Myothit (South)",
    "Hmawbi",
    "Shwepyithar",
    "Kyauktan",
    "Dala",
    "Tharketa",
  ],
  mandalay: ["Mandalay", "Pyinoolwin", "Amarapura", "Patheingyi", "Aungmyethazan"],
  shan: ["Taunggyi", "Nansang", "Kyaingtong", "Lashio", "Muse"],
  naypyitaw: ["Zabuthiri", "Dekkhinathiri", "Pobbathiri"],
  magway: ["Magway", "Pakokku", "Chauk", "Minbu", "Aunglan"],
  mon: ["Mawlamyine", "Thaton", "Kyaikto", "Mudon"],
  others: ["Other Region"],
};
export const regionTownships: Typeregion = {
  ayeyarwady: [
  "Bogale",
  "Danubyu",
  "Dedaye",
  "Einme",
  "Hinthada",
  "Ingapu",
  "Kangyidaunt",
  "Kyaiklat",
  "Kyangin",
  "Kyaunggon",
  "Kyonpyaw",
  "Labutta",
  "Lemyethna",
  "Maubin",
  "Mawlamyinegyun",
  "Myanaung",
  "Myaungmya",
  "Ngapudaw",
  "Nyaungdon",
  "Pantanaw",
  "Pathein",
  "Pyapon",
  "Thabaung",
  "Wakema",
  "Yegyi",
  "Zalun",
],
bago_east: [
  "Bago",
  "Daik-U",
  "Htantabin",
  "Kawa",
  "Kyaukkyi",
  "Kyauktaga",
  "Nyaunglebin",
  "Oktwin",
  "Phyu",
  "Shwegyin",
  "Taungoo",
  "Thanatpin",
  "Waw",
  "Yedashe"
],
bago_west: [
    "Gyobingauk",
    "Letpadan",
    "Minhla",
    "Monyo",
    "Nattalin",
    "Okpho",
    "Padaung",
    "Paukkhaung",
    "Paungde",
    "Pyay",
    "Shwedaung",
    "Thayarwady",
    "Thegon",
    "Zigon"
],
chin: [
  "Falam",
  "Hakha",
  "Kanpetlet",
  "Matupi",
  "Mindat",
  "Paletwa",
  "Tedim",
  "Thantlang",
  "Tonzang"
],
kachin: [
  "Bhamo",
  "Chipwi",
  "Hpakant",
  "Injangyang",
  "Khaunglanhpu",
  "Machanbaw",
  "Mansi",
  "Mogaung",
  "Mohnyin",
  "Momauk",
  "Myitkyina",
  "Nawngmun",
  "Puta-O",
  "Shwegu",
  "Sumprabum",
  "Tanai",
  "Tsawlaw",
  "Waingmaw"
],
kayah: [
  "Bawlake",
  "Demoso",
  "Hpasawng",
  "Hpruso",
  "Loikaw",
  "Mese",
  "Shadaw"
],
kayin: [
  "Hlaingbwe",
  "Hpa_An",
  "Hpapun",
  "Kawkareik",
  "Kyainseikgyi",
  "Myawaddy",
  "Thandaunggyi"
],
  yangon: [
    "Ahlone",
    "Bahan",
    "Botahtaung",
    "Cocokyun",
    "Dagon",
    "Dagon_Myothit_East",
    "Dagon_Myothit_North",
    "Dagon_Myothit_Seikkan",
    "Dagon_Myothit_South",
    "Dala",
    "Dawbon",
    "Hlaing",
    "Hlaingtharya",
    "Hlegu",
    "Hmawbi",
    "Htantabin",
    "Insein",
    "Kamaryut",
    "Kawhmu",
    "Kayan",
    "Kungyangon",
    "Kyauktada",
    "Kyauktan",
    "Kyeemyindaing",
    "Lanmadaw",
    "Latha",
    "Mayangone",
    "Mingaladon",
    "Mingalartaungnyunt",
    "North_Okkalapa",
    "Pabedan",
    "Pazundaung",
    "Sanchaung",
    "Seikgyikanaungto",
    "Seikkan",
    "Shwepyithar",
    "South_Okkalapa",
    "Taikkyi",
    "Tamwe",
    "Thaketa",
    "Thanlyin",
    "Thingangyun",
    "Thongwa",
    "Twantay",
    "Yankin",
    "Hlaingtharya_East",
    "Hlaingtharya_West"
  ],
  mandalay: [
    "Amarapura",
    "Aungmyaythazan",
    "Chanayethazan",
    "Chanmyathazi",
    "Kyaukpadaung",
    "Kyaukse",
    "Madaya",
    "Mahaaungmyay",
    "Mahlaing",
    "Meiktila",
    "Mogoke",
    "Myingyan",
    "Myittha",
    "Natogyi",
    "Ngazun",
    "Nyaung_U",
    "Patheingyi",
    "Pyawbwe",
    "Pyigyitagon",
    "Pyinoolwin",
    "Singu",
    "Sintgaing",
    "Tada-U",
    "Taungtha",
    "Thabeikkyin",
    "Thazi",
    "Wundwin",
    "Yamethin"
  ],
  mon: [
    "Bilin",
    "Chaungzon",
    "Kyaikmaraw",
    "Kyaikto",
    "Mawlamyine",
    "Mudon",
    "Paung",
    "Thanbyuzayat",
    "Thaton",
    "Ye"
  ],
  naypyitaw: [
    "Det Khi Na Thi Ri",
    "Lewe",
    "Oke Ta Ra Thi Ri",
    "Poke Ba Thi Ri",
    "Pyinmana",
    "Tatkon",
    "Za Bu Thi Ri",
    "Zay Yar Thi Ri"
  ],
  rakhine:[
    "Ann",
    "Buthidaung",
    "Gwa",
    "Kyaukpyu",
    "Kyauktaw",
    "Maungdaw",
    "Minbya",
    "Mrauk_U",
    "Munaung",
    "Myebon",
    "Pauktaw",
    "Ponnagyun",
    "Ramree",
    "Rathedaung",
    "Sittwe",
    "Thandwe",
    "Toungup"
  ],
  sagaing: [
    "Ayadaw",
    "Banmauk",
    "Budalin",
    "Chaung_U",
    "Hkamti",
    "Homalin",
    "Indaw",
    "Kale",
    "Kalewa",
    "Kanbalu",
    "Kani",
    "Katha",
    "Kawlin",
    "Khin-U",
    "Kyunhla",
    "Lahe",
    "Layshi",
    "Mawlaik",
    "Mingin",
    "Monywa",
    "Myaung",
    "Myinmu",
    "Nanyun",
    "Pale",
    "Paungbyin",
    "Pinlebu",
    "Sagaing",
    "Salingyi",
    "Shwebo",
    "Tabayin",
    "Tamu",
    "Taze",
    "Tigyaing",
    "Wetlet",
    "Wuntho",
    "Ye-U",
    "Yinmarbin"
  ],
  shan_east: [
    "Ho-Tawng",
    "Kengtung",
    "Mong Hpen",
    "Mong Kar",
    "Mong Pawk",
    "Monghpyak",
    "Monghsat",
    "Mongkhet",
    "Mongla",
    "Mongping",
    "Mongton",
    "Mongyang",
    "Mongyawng",
    "Nam Hpai",
    "Tachileik"
  ],
  shan_north: [
    "Aik Chan",
    "Chinshwehaw Sub township",
    "Hkun Mar",
    "Hopang",
    "Hsawng Hpa",
    "Hseni",
    "Hsipaw",
    "Ka Lawng Hpar",
    "Kawng Min Hsang",
    "Konkyan",
    "Konkyan Kokang SAZ",
    "Kunlong",
    "Kutkai",
    "Kyaukme",
    "Lashio",
    "Laukkaing",
    "Laukkai ng Kokang SAZ",
    "Lin Haw",
    "Long Htan",
    "Mabein",
    "Man Man Hseng",
    "Man Tun",
    "Manton",
    "Matman",
    "Mongmao",
    "Mongmit",
    "Mongyai",
    "Muse",
    "Nam Hkam Wu",
    "Nam Tit",
    "Namhkan",
    "Namhsan",
    "Namtu",
    "Nar Kawng",
    "Nar Wee",
    "Narphan",
    "Nawng Hkit",
    "Nawnghkio",
    "Pang Hkam",
    "Pang Yang",
    "Pangsang Panghkam",
    "Pangwaun",
    "Tangyan",
    "Yawng Lin",
    "Yin Pang"
  ],
  shan_south: [
    "Hopong",
    "Hsihseng",
    "Kalaw",
    "Aungban",
    "Shwe Nyaung",
    "Kunhing",
    "Kyethi",
    "Laihka",
    "Langkho",
    "Lawksawk",
    "Loilen",
    "Mawkmai",
    "Monghsu",
    "Mongkaing",
    "Mongnai",
    "Mongpan",
    "Nansang",
    "Nyaungshwe",
    "Pekon",
    "Pindaya",
    "Pinlaung",
    "Taunggyi",
    "Ywangan"
  ],
  tanintharyi: [
    "Bokpyin",
    "Dawei",
    "Kawthoung",
    "Kyunsu",
    "Launglon",
    "Myeik",
    "Palaw",
    "Tanintharyi",
    "Thayetchaung",
    "Yebyu"
  ],
  magway: [
    "Aunglan",
    "Chauk",
    "Gangaw",
    "Kamma",
    "Magway",
    "Minbu",
    "Mindon",
    "Minhla",
    "Myaing",
    "Myothit",
    "Natmauk",
    "Ngape",
    "Pakokku",
    "Pauk",
    "Pwintbyu",
    "Salin",
    "Saw",
    "Seikphyu",
    "Sidoktaya",
    "Sinbaungwe",
    "Taungdwingyi",
    "Thayet",
    "Tilin",
    "Yenangyaung",
    "Yesagyo"
  ],
  others: ["Other Region"],
};
export const hospitalNames = [
  "Yangon General Hospital",
  "North Okkala General Hospital",
  "500 Naypyitaw Children Hospital",
  "550 Mandalay Children Hospital",
  "Mandalay General Hospital",
  "Magway General Hospital",
  "Magway General Hospital (Child Ward)",
  "Taunggyi Women and Children Hospital",
  "Taunggyi Sao San Tun Hospital",
  "Mawlamyine Women and Children Hospital",
  "Yangon Children Hospital",
  "1000 Naypyitaw General Hospital",
  "Others",
];
export const insulinTypes = [
  "Rapid Insulin",
  "Premixed Insulin",
  "Basal Bolus"
];
export const redeemStatus = [enumStatus.ACTIVE, enumStatus.INACTIVE];
export const couponStatus = [enumStatus.EXPIRED, enumStatus.ACTIVE, enumStatus.REDEEMED];
export const range_filter = ["weekly", "monthly"];
export const doctorComments = [
  "No pregnancy",
  "Wrong client information",
  "Unavailable services",
  "End of project",
  "Other",
];
export const serviceCategory = ["Ultrasound", "Blood test for antenatal screening"];
export const cdicServiceCategory = ["CDiC Program"];
export const referredBy = [enumReferred.MYAN_CARE, enumReferred.VOLUNTEER];

export const seeingDisables = [
  "No difficulty",
  "Yes, some difficulty",
  "Yes, a lot of difficulty",
  "Cannot see at all",
];
export const hearingDisables = [
  "No difficulty",
  "Yes, some difficulty",
  "Yes, a lot of difficulty",
  "Cannot hear at all",
];
export const walkingDisables = [
  "No difficulty",
  "Yes, some difficulty",
  "Yes, a lot of difficulty",
  "Cannot walk or climb at all",
];
export const concentrationDisables = [
  "No difficulty",
  "Yes, some difficulty",
  "Yes, a lot of difficulty",
  "Cannot concentrate or remember at all",
];
export const selfCareDisables = [
  "No difficulty",
  "Yes, some difficulty",
  "Yes, a lot of difficulty",
  "Cannot do it at all",
];
export const communicationDisables = [
  "No difficulty",
  "Yes, some difficulty",
  "Yes, a lot of difficulty",
  "Cannot communicate at all",
];

export const occasionData = ["I (Interval)", "PP (Post Partum)", "PA (Post Abortion)"];

export const deliverySiteOptions = [
  "Public Hospital/ Health Centers",
  "Private Hospital/ Clinics",
  "Home",
  "Other",
];

export enum enumDiscount {
  FLAT = "flat",
  PERCENTAGE = "percentage",
}
export const discountOptions = [enumDiscount.FLAT, enumDiscount.PERCENTAGE];
